module.exports = __webpack_public_path__ + "img/result_ceil.39a5b20c.jpg";